var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature5Icon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.6886 22.5229H11.5856",
    stroke: "black",
    strokeWidth: 1.9294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6384 40.9421V29.8906M22.6384 29.8906L28.1641 35.4164M22.6384 29.8906L17.1126 35.4164",
    stroke: "black",
    strokeWidth: 1.9294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6384 4.10376V15.1553M22.6384 15.1553L28.1641 9.62952M22.6384 15.1553L17.1126 9.62952",
    stroke: "black",
    strokeWidth: 1.9294,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature5Icon1);
export default __webpack_public_path__ + "static/media/feature5-icon-1.f4d0643bb9d368874642c23f36ddaa0a.svg";
export { ForwardRef as ReactComponent };